
'use client'

import Link from "next/link";

import { openCookiePreferences } from "@/lib/cookie-consent";
import { BusinessIdentification } from "@/components/layout/business-identification";

// No discovery links: the footer nav is the legal pages, Help and Cookie
// preferences. Browse, Marketplace and Sell were removed on an owner decision
// (2026-09-28). The header already links Marketplace for everyone and
// Sell for anyone who is not yet a seller.
//
// Browse used to be here as the crawl path into the catalog, and that is no
// longer the footer's job: src/app/sitemap.ts lists every live product, every
// indexable tag and every seller profile URL directly, and /browse itself is
// still linked in served HTML from the breadcrumb on every product page, which
// the server renders (src/app/product/[id]/product-client.tsx).
const legalLinks = [
  // Not legal, but the footer's one row of links: the teaching hub, which is
  // indexable and needs a link from every page to be found (2026-10-22).
  { href: "/teaching", label: "For teachers" },
  { href: "/terms", label: "Terms of Service" },
  { href: "/privacy-policy", label: "Privacy Policy" },
  { href: "/fees", label: "Fee Disclosure" },
  { href: "/guidelines", label: "Seller Guidelines" },
  { href: "/help", label: "Help" },
];

export function Footer() {
  return (
    <footer className="border-t border-border mt-2">
      <div className="py-8 -mx-[calc((100vw-100%)/2-3rem)]">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link href="/" className="text-xl font-bold">
              supa<span className="text-primary">.</span>place
            </Link>
            <p className="text-sm text-muted-foreground">&copy; {new Date().getFullYear()} supa.place. All rights reserved.</p>
          </div>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {legalLinks.map((link) => (
              <Link key={link.href} href={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {link.label}
              </Link>
            ))}
            <button
              type="button"
              onClick={() => openCookiePreferences()}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Cookie preferences
            </button>
          </nav>
        </div>
        <BusinessIdentification />
      </div>
    </footer>
  );
}
